
  function toggleMobileMenu() {
    const menu = document.getElementById('main-menu');
    const isOpen = menu.classList.toggle('show');

    // Prevent background scroll when menu is open
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }

  function closeMobileMenu() {
    document.getElementById('main-menu').classList.remove('show');
    document.body.style.overflow = 'auto';
  }

